import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { getDatabase, ref, onValue } from "firebase/database"; // Import Firebase functions
import "../../Styles/UX/FlashPopUp.css";
import exit from "../../assets/exit.png";
import whiteLoader from "../../assets/whiteLoader.gif";
import ReactPlayer from "react-player";
import { getProductById, getReviewsById } from "../../Utils/Utils";

const FlashPopUp = ({
  darkMode,
  setSelectedProduct,
  setToggleDetailOverlay,
  setReviews,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false); // Control visibility based on flashSaleStatus
  const [flashSaleContent, setFlashSaleContent] = useState({});
  const [loading, setLoading] = useState(false);
  const [associatedProduct, setAssociatedProduct] = useState(null);
  const handleFlashClick = () => {
    if (!associatedProduct) return;
    setLoading(true);
    console.log("associated product id", flashSaleContent.associatedProduct);
    console.log(associatedProduct);
    var pr = {
      id: associatedProduct.id,
      imgSrc: associatedProduct.imagesUrls || [],
      name: associatedProduct.productName,
      price: associatedProduct.price,
      brand: associatedProduct.brandName,
      tags: associatedProduct.tags,
      reviews: [{ name: "hatem", rating: 5, comment: "Best product ever" }],
      numberSelles: associatedProduct.numberSelles,
      varients: associatedProduct.varients || [],
      availabilityDate: associatedProduct.availabilityDate,
      productDescription: associatedProduct.productDescription,
      outOfStock: associatedProduct.outOfStock,
      maunalFile: associatedProduct.maunalFile,
    };

    getReviewsById(associatedProduct.id).then((res) => {
      console.log(res);
      var revs = [];
      for (let index = 0; index < res.length; index++) {
        const element = res[index];
        revs.push({
          client: element.reviewerName,
          review: element.reviewText,
          date: element.createdAt,
          status: element.status,
        });
      }
      setReviews(revs);
    });

    setSelectedProduct(pr);
    console.log("associated product", pr);
    setTimeout(() => {
      setToggleDetailOverlay(true);
      setLoading(false);
    }, 3000);
  };
  // Retrieve flash sale data from the real-time database
  useEffect(() => {
    const db = getDatabase();
    const flashSaleRef = ref(db, "flash-sales"); // Assuming this is the path to the flash sale object

    // Listen for changes in the flash sale data
    onValue(flashSaleRef, (snapshot) => {
      const data = snapshot.val();
      console.log("data updated", data);
      // If the flash sale is active, set content and make the popup visible

      if (data) {
        // Assuming data is an object, get the first matching entry
        const activeFlashSale = Object.values(data).find(
          (item) => item.flashSaleStatus === true,
        );

        if (activeFlashSale) {
          console.log("Active Flash Sale:", activeFlashSale);
          setFlashSaleContent(activeFlashSale);
          setIsVisible(true);
        } else {
          setIsVisible(false); // Hide the popup if no active flash sale
        }
      } else {
        setIsVisible(false);
      }
    });
  }, []);

  // Fetch associated product when flashSaleContent is updated
  useEffect(() => {
    if (flashSaleContent.associatedProduct) {
      getProductById(flashSaleContent.associatedProduct)
        .then((product) => {
          if (product) {
            setAssociatedProduct(product);
          }
        })
        .catch((error) => {
          console.error("Error fetching product:", error);
          setAssociatedProduct(null);
        });
    } else {
      setAssociatedProduct(null);
    }
  }, [flashSaleContent]);
  // Image slider effect when mediaType is "slider"
  useEffect(() => {
    const imagesToUse =
      associatedProduct && associatedProduct.imagesUrls
        ? associatedProduct.imagesUrls
        : flashSaleContent.mediaContent || [];
    if (flashSaleContent.mediaType === "slider" && imagesToUse.length > 0) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % imagesToUse.length);
      }, 5000); // Adjust the interval as needed
      return () => clearInterval(interval);
    }
  }, [flashSaleContent, associatedProduct]);

  
  // Close button handler
  const closeSale = () => {
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ x: "-100%", opacity: 0 }}
          animate={{ x: 0, opacity: 1, transition: { delay: 5 } }}
          exit={{ x: "-100%", opacity: 0 }}
          className={
            darkMode
              ? flashSaleContent.mediaType !== "photo"
                ? "dark-mode flash-sale-container video-flash"
                : "dark-mode flash-sale-container"
              : flashSaleContent.mediaType !== "photo"
                ? "flash-sale-container video-flash"
                : "flash-sale-container"
          }
        >
          <div
            className={
              darkMode
                ? "inverted-image overlay-close-btn"
                : "overlay-close-btn"
            }
            onClick={closeSale}
          >
            <img src={exit} alt="Close Flash Sale" />
          </div>

          {flashSaleContent.mediaType === "photo" ? (
            <div className="flex-column  bold align-items-center">
              <motion.img
                key={currentIndex}
                src={associatedProduct && associatedProduct.imagesUrls[0]}
                alt="Flash Sale Product Image"
                className="flash-sale-image"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
              />

              <p className={darkMode ? "smaller-text white center-text my-10" : "my-10 smaller-text center-text black"}>
                {associatedProduct && associatedProduct.productName} 
              </p>
              <p className={darkMode ? "small-text white" : "small-text black"}>
                {flashSaleContent.flashSaleContent} 
              </p>

              <div
                className="action-button bg-red my-10"
                onClick={() => handleFlashClick()}
              >
                <motion.p
                  className="btn small-text"
                  initial={{ opacity: 1 }}
                  animate={loading ? { opacity: 0 } : { opacity: 1 }}
                >
                  Check Now
                </motion.p>

                <motion.div
                  className="btn-loader absolute flex justify-center align-items-center top0 z-1"
                  initial={{ opacity: 0 }}
                  animate={loading ? { opacity: 1 } : { opacity: 0 }}
                >
                  <img src={whiteLoader} alt="loading" />
                </motion.div>
              </div>
            </div>
          ) : (
            <ReactPlayer
              url={flashSaleContent.mediaContent[0]}
              playing
              width="95%"
              height="85%"
              className="video"
              muted
            >
              <div className="action-button bg-red">
                <p className="btn">action</p>
              </div>
            </ReactPlayer>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FlashPopUp;
